import {createURL} from "./client";
import axios from "axios";
import {generateIdempotencyKey} from "../utils/idempotency";

export const FINISH_REASON_TIMEOUT = "timeout";
export const WORD_SEARCH_MODE = "word_search_7x7";

// createGame создаёт новую игру в режиме поиска слов 7x7.
export async function createGame(options = {}) {
    const payload = {
        mode: options.mode || WORD_SEARCH_MODE,
    };

    return await axios.post(createURL("/api/game/start"), payload);
}

// getActiveGame возвращает активную игру игрока, если она есть.
export async function getActiveGame() {
    return await axios.get(createURL("/api/game/active"));
}

// useHint применяет подсказку в игре.
export async function useHint(gameID, hintType) {
    return await axios.post(createURL(`/api/game/${gameID}/hint`), {
        type: hintType,
    });
}

// buyHint списывает монеты со счёта игрока и добавляет заряд подсказки.
export async function buyHint(hintType, options = {}) {
    const idempotencyKey = options.idempotencyKey || generateIdempotencyKey();
    const payload = {type: hintType};
    if (options.gameId !== undefined && options.gameId !== null) {
        payload.game_id = options.gameId;
    }
    return await axios.post(
        createURL("/api/player/buy-hint"),
        payload,
        {headers: {"Idempotency-Key": idempotencyKey}},
    );
}

// finishGame завершает игру по инициативе клиента.
export async function finishGame(gameID, reason = FINISH_REASON_TIMEOUT) {
    return await axios.post(createURL(`/api/game/${gameID}/finish`), {
        reason,
    });
}

// submitWord отправляет найденное слово и путь клеток для проверки.
export async function submitWord(gameID, payload) {
    return await axios.post(createURL(`/api/game/${gameID}/word`), {
        mode: payload?.mode || WORD_SEARCH_MODE,
        word: payload?.word || "",
        cells: Array.isArray(payload?.cells) ? payload.cells : [],
    });
}
